module.exports = __webpack_public_path__ + "static/media/pic77.89892c08.jpg";